import { slideUp, slideDown } from "@/scripts/common/slide";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-printingsolutionscards").forEach((el) => {
    const cardImages = el.querySelector(".card-images");

    el.querySelectorAll("[aria-controls]").forEach((trigger) => {
      trigger.addEventListener("click", async () => {
        const controlsId = trigger.getAttribute("aria-controls");
        const targetElement = document.getElementById(controlsId);

        el.querySelectorAll('[aria-controls][aria-expanded="true"]').forEach((otherTrigger) => {
          const otherControlsId = otherTrigger.getAttribute("aria-controls");
          const otherTargetElement = document.getElementById(otherControlsId);

          slideUp(otherTargetElement);
          otherTrigger.setAttribute("aria-expanded", "false");
        });

        trigger.setAttribute("aria-expanded", "true");

        const currentActive = cardImages.querySelector(".is-active");
        const currentZ = parseInt(currentActive.style.zIndex);
        currentActive.classList.remove("is-active");

        const nextActive = cardImages.querySelector(`[data-id="${trigger.dataset.id}"]`);
        nextActive.style.zIndex = currentZ + 1;
        nextActive.classList.add("is-transitioning");

        setTimeout(() => {
          nextActive.classList.remove("is-transitioning");
          nextActive.classList.add("is-active");
        }, 300);

        await slideDown(targetElement);
      });
    });
  });
});
